var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 12.1428H9C9.55 12.1428 10 11.7089 10 11.1785V6.35706H11.59C12.48 6.35706 12.93 5.31562 12.3 4.70811L7.71 0.282002C7.61749 0.192609 7.5076 0.121687 7.38662 0.0732974C7.26565 0.0249077 7.13597 0 7.005 0C6.87403 0 6.74435 0.0249077 6.62338 0.0732974C6.5024 0.121687 6.39251 0.192609 6.3 0.282002L1.71 4.70811C1.08 5.31562 1.52 6.35706 2.41 6.35706H4V11.1785C4 11.7089 4.45 12.1428 5 12.1428ZM1 14.0714H13C13.55 14.0714 14 14.5053 14 15.0357C14 15.5661 13.55 16 13 16H1C0.45 16 0 15.5661 0 15.0357C0 14.5053 0.45 14.0714 1 14.0714Z",
    fill: "#282828"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.3882d8b5.svg";
export { ForwardRef as ReactComponent };